import { NewChatView } from "@components/view/new-chat-view";

export function HomeView() {
  return (<>
    <NewChatView />
  </>);
}

